<template>
  <base-amount
    :unit="getUnit()"
    :value="getValue()"
    :options="{ minimumFractionDigits: 0, maximumFractionDigits: 3 }"
  ></base-amount>
</template>

<script>
import BaseAmount from '@kanrisha/components/Elements/Amount/BaseAmount';

export default {
  components: {
    BaseAmount,
  },
  props: {
    unit: { type: String, default: () => null },
    value: { type: [Number, String], default: () => 0.0 },
    schema: { type: String, default: '{{ unit }} {{ value }}' },
  },
  setup(props) {
    const getUnit = () => {
      switch (props.unit) {
        case 'milligram':
        case 'mg':
          return 'mg'; // todo: replace with translations once amount translations are added to forgeron
        case 'gram':
        case 'g':
          return 'g'; // todo: replace with translations once amount translations are added to forgeron
        case 'kilogram':
        case 'kg':
          return 'kg'; // todo: replace with translations once amount translations are added to forgeron
        default:
          if (props.value >= 1000) {
            return 'kg';
          }
          if (props.value >= 1) {
            return 'g';
          }
          if (props.value > 0) {
            return 'mg';
          }

          return 'g';
      }
    };

    const getValue = () => {
      switch (getUnit()) {
        case 'mg':
          return props.value * 1000;
        case 'g':
          return props.value;
        case 'kg':
          return props.value / 1000;
        default:
          return props.value;
      }
    };

    return {
      getUnit,
      getValue,
    };
  },
};
</script>
